var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"stock-info-box-right"},_vm._l((_setup.displayData),function(item,index){return _c('div',{key:index,staticClass:"card-item"},[_c('p',[_vm._v(_vm._s(item.value)+_vm._s(item.unit))]),_c('p',[_vm._v(_vm._s(item.label))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }